"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const web_sentry_1 = require("@snapchat/web-sentry");
const web_graphene_reporting_1 = require("@snapchat/web-graphene-reporting");
const web_core_ui_1 = require("@snapchat/web-core-ui");
const __1 = require("../..");
const web_consumer_nav_1 = require("@snapchat/web-consumer-nav");
const web_head_meta_1 = require("@snapchat/web-head-meta");
const web_i18n_1 = require("@snapchat/web-i18n");
class ErrorBoundary extends react_1.Component {
    constructor(props) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }
    state = {
        hasError: false,
    };
    static getDerivedStateFromError(_error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
        const metricsPrefix = this.props.metricsPrefix;
        void (0, web_graphene_reporting_1.incrementCounter)(`${metricsPrefix}.errorBoundary`);
        (0, web_sentry_1.logSentryError)(`Error occured :${error.message} at ${errorInfo.componentStack}`);
    }
    onClick() {
        const metricsPrefix = this.props.metricsPrefix;
        void (0, web_graphene_reporting_1.incrementCounter)(`${metricsPrefix}.errorBoundary`);
    }
    render() {
        const { locale, localeChange, pageType, webClientId, webPageViewTraceId } = this.props;
        if (this.state.hasError) {
            return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(web_head_meta_1.HeadMeta, { lang: locale, direction: (0, web_i18n_1.getDirectionForLocale)(locale) }), (0, jsx_runtime_1.jsx)(__1.PageFrame, { locale: locale, localeChange: localeChange, appType: web_consumer_nav_1.ConsumerApp.Unset, pageType: pageType, downloadUrl: (0, __1.generateAttributedDownloadUrl)(pageType), webClientId: webClientId, webPageViewTraceId: webPageViewTraceId, children: (0, jsx_runtime_1.jsx)(web_core_ui_1.ErrorScreen, { onClick: this.onClick }) })] }));
        }
        return this.props.children;
    }
}
exports.default = ErrorBoundary;
//# sourceMappingURL=index.js.map